import { dataLineChartAltSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLineChartAltSolid = /*#__PURE__*/createIcon(dataLineChartAltSolid)
export default IconLineChartAltSolid
